import { create } from 'zustand';
import { AnnualTamPrimeAggregate } from '../types/primes';

export type AnnualTamPrimesCacheEntry = {
  aggregate: AnnualTamPrimeAggregate;
  lastFetchedAt: number;
};

export type AnnualTamPrimesState = {
  byKey: Record<string, AnnualTamPrimesCacheEntry>;
  getCache: (cacheKey: string) => AnnualTamPrimesCacheEntry | null;
  setCache: (cacheKey: string, aggregate: AnnualTamPrimeAggregate) => void;
  invalidateCache: (cacheKey: string) => void;
};

export const useAnnualTamPrimesStore = create<AnnualTamPrimesState>()((set, get) => ({
  byKey: {},
  getCache: (cacheKey) => get().byKey[cacheKey] ?? null,
  setCache: (cacheKey, aggregate) =>
    set((state) => ({
      byKey: {
        ...state.byKey,
        [cacheKey]: {
          aggregate,
          lastFetchedAt: Date.now(),
        },
      },
    })),
  invalidateCache: (cacheKey) =>
    set((state) => {
      if (!(cacheKey in state.byKey)) {
        return state;
      }

      const nextByKey = { ...state.byKey };
      delete nextByKey[cacheKey];
      return { byKey: nextByKey };
    }),
}));
